import Callbacks from "./callbacks"
import RequestBody from "./request-body"
import OperationLink from "./operation-link.jsx"
import Servers from "./servers"
import RequestBodyEditor from "./request-body-editor"
import HttpAuth from "./http-auth"
import OperationServers from "./operation-servers"

export default {
  Callbacks,
  HttpAuth,
  RequestBody,
  Servers,
  RequestBodyEditor,
  OperationServers,
  operationLink: OperationLink
}



// WEBPACK FOOTER //
// ./src/core/plugins/oas3/components/index.js